import { type Analytics, getAnalytics } from "firebase/analytics";
import posthog from 'posthog-js';
import { app } from "./firebase";


const isProd = import.meta.env.PROD || import.meta.env.VITE_ENV === 'prod' || import.meta.env.VITE_ENV === 'production' || (!import.meta.env.VITE_ENV && !window.location.hostname.startsWith('localhost'));

export let analytics: Analytics | null = null;

export const initDevTools = () => {
  if (isProd) {
    if (!posthog.__loaded) {
      posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
        api_host: 'https://eu.i.posthog.com',
        defaults: '2025-05-24',
      });
    }
  }
}

export const initAnalytics = () => {
  if (isProd) {
    analytics = getAnalytics(app)
  }
}